import 'raf/polyfill'
import 'regenerator-runtime/runtime'
import 'requestidlecallback'
import 'process'
import hrtime from 'browser-process-hrtime'
process.hrtime = hrtime as any
